module.exports = __webpack_public_path__ + "img/icon-search-black.4caf2433.svg";